/* eslint-disable prettier/prettier */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MaterialGrid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Divider from '@material-ui/core/Divider';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import PrimaryButton from 'common/components/buttons/primaryButton';
import SecondaryButton from 'common/components/buttons/secondaryButton';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import { BASE_S3 } from 'config/consts';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, getFormValues, change } from 'redux-form';
import { uploadImageToS3 } from 'modules/owner/pages/actions/actionsFile';
import * as XLSX from 'xlsx';
import {
  uploadVoucherCodes,
  getVoucherCodesCount,
  deleteUnusedVoucherCodes,
} from 'modules/owner/pages/sales/productOrders/productOrdersActions';

const PAYMENT_OPTIONS = [
  { value: 'credit_and_payment', label: 'Créditos e pagamento' },
  { value: 'credit_only', label: 'Somente créditos' },
  { value: 'payment_only', label: 'Somente pagamento' },
];

const RECURRENCE_OPTIONS = [
  { value: 'single', label: 'Venda única' },
  { value: 'weekly', label: 'Semanal' },
  { value: 'biweekly', label: 'Quinzenal' },
  { value: 'monthly', label: 'Mensal' },
  { value: 'bimonthly', label: 'Bimestral' },
  { value: 'quarterly', label: 'Trimestral' },
  { value: 'semiannual', label: 'Semestral' },
  { value: 'annual', label: 'Anual' },
];

const PAYMENT_METHODS = [
  { value: 'pix', label: 'PIX' },
  { value: 'credit_card', label: 'Cartão de Crédito' },
  { value: 'boleto', label: 'Boleto' },
];

class Produto extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paymentOption: props.formValues?.payment_option || 'credit_and_payment',
      paymentMethods: props.formValues?.payment_methods || ['pix', 'credit_card', 'boleto'],
      allowInstallments: props.formValues?.allow_installments || false,
      installmentsCount: props.formValues?.installments_count || 12,
      installmentsFree: props.formValues?.installments_free || 0,
      useVouchers: props.formValues?.use_vouchers || false,
      useOwnCodes: props.formValues?.use_own_codes || false,
      singleProduct: props.formValues?.single_product || false,
      recurrenceType: props.formValues?.recurrence_type || 'single',
      products: props.formValues?.products || [],
      expandedProduct: 0,
      uploadingImage: null,
      dateValidityVoucher: props.formValues?.date_validity_voucher || '',
      voucherCounts: {},
      pendingFiles: props.formValues?.pending_voucher_files || {},
      uploadingIndex: null,
      deletingIndex: null,
    };
  }

  componentDidMount() {
    // Carregar dados salvos do formulário
    this.loadFormData();
  }

  componentDidUpdate(prevProps, prevState) {
    // Atualizar state apenas quando o ID da atividade mudar
    const { formValues } = this.props;
    const prevFormValues = prevProps.formValues;
    
    // Atualizar apenas se o ID mudou (indica nova atividade carregada)
    const idChanged = formValues?.id && formValues.id !== prevFormValues?.id;
    
    if (idChanged) {
      this.loadFormData();
    }

    // Ativa has_voucher_import em todos os produtos quando useOwnCodes for ativado
    if (this.state.useOwnCodes && this.state.products.length > 0) {
      const needsUpdate = this.state.products.some((product) => !product?.has_voucher_import);
      if (needsUpdate) {
        const updatedProducts = this.state.products.map((product) => ({
          ...product,
          has_voucher_import: true,
        }));
        this.setState({ products: updatedProducts });
        this.props.change('products', updatedProducts);
        return;
      }
    }

    // Busca a contagem de vouchers quando os produtos ou o switch de códigos próprios mudarem
    if (
      this.state.useOwnCodes &&
      (prevState.products !== this.state.products || prevState.useOwnCodes !== this.state.useOwnCodes)
    ) {
      this.fetchVoucherCounts();
    }
  }

  loadFormData = () => {
    const { formValues } = this.props;
    if (!formValues) return;
    
    const updates = {};
    
    if (formValues.products && formValues.products.length > 0) {
      updates.products = formValues.products;
    }
    if (formValues.payment_option) {
      updates.paymentOption = formValues.payment_option;
    }
    if (formValues.payment_methods) {
      updates.paymentMethods = formValues.payment_methods;
    }
    if (formValues.allow_installments !== undefined) {
      updates.allowInstallments = formValues.allow_installments;
    }
    if (formValues.max_installments) {
      updates.installmentsCount = formValues.max_installments;
    }
    if (formValues.free_installments !== undefined) {
      updates.installmentsFree = formValues.free_installments;
    }
    if (formValues.use_vouchers !== undefined) {
      updates.useVouchers = formValues.use_vouchers;
    }
    if (formValues.use_own_codes !== undefined) {
      updates.useOwnCodes = formValues.use_own_codes;
    }
    if (formValues.single_product !== undefined) {
      updates.singleProduct = formValues.single_product;
    }
    if (formValues.recurrence_type) {
      updates.recurrenceType = formValues.recurrence_type;
    }
    if (formValues.date_validity_voucher) {
      updates.dateValidityVoucher = formValues.date_validity_voucher;
    }
    if (formValues.pending_voucher_files && Object.keys(formValues.pending_voucher_files).length > 0) {
      updates.pendingFiles = formValues.pending_voucher_files;
    }
    
    if (Object.keys(updates).length > 0) {
      this.setState(updates);
    }
  }

  // Sincroniza os arquivos pendentes de voucher com o redux-form para que sobrevivam
  // à troca de abas do wizard até o salvamento final da atividade
  syncPendingFilesToForm = (pendingFiles) => {
    const sanitized = Object.keys(pendingFiles).reduce((acc, key) => {
      const { fileName, codes, codesCount } = pendingFiles[key];
      acc[key] = { fileName, codes, codesCount };
      return acc;
    }, {});
    this.props.change('pending_voucher_files', sanitized);
  };

  // Busca a contagem de vouchers (total, disponíveis e usados) para os produtos que já possuem ID
  fetchVoucherCounts = async () => {
    const productsWithId = this.state.products.filter((product) => product?.id);
    if (productsWithId.length === 0) return;

    const promises = productsWithId.map((product) =>
      this.props
        .getVoucherCodesCount(product.id)
        .then((count) => ({ id: product.id, count }))
        .catch(() => ({ id: product.id, count: { total: 0, available: 0, used: 0 } }))
    );

    const results = await Promise.all(promises);
    const newCounts = {};
    results.forEach(({ id, count }) => {
      newCounts[id] = count;
    });

    this.setState({ voucherCounts: newCounts });
  };

  // Lê o arquivo selecionado (csv/xlsx/xls) e extrai os códigos de voucher
  handleFileSelect = (index, event) => {
    const file = event.target.files?.[0] || event.dataTransfer?.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (evt) => {
      try {
        const bstr = evt.target.result;
        const wb = XLSX.read(bstr, { type: 'binary' });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
        const codes = data
          .slice(1)
          .map((row) => row[0])
          .filter((code) => code != null && code !== '')
          .map(String);

        if (codes.length === 0) {
          alert('Nenhum código válido foi encontrado no arquivo.');
          return;
        }

        // Valida que a quantidade de códigos é igual ao estoque do produto
        const stock = parseInt(this.state.products[index]?.stock, 10);
        if (isNaN(stock) || codes.length !== stock) {
          alert(
            `A quantidade de códigos no arquivo (${
              codes.length
            }) deve ser igual ao estoque do produto (${isNaN(stock) ? 'não definido' : stock}).`
          );
          return;
        }

        this.setState((prevState) => ({
          pendingFiles: {
            ...prevState.pendingFiles,
            [index]: {
              file,
              fileName: file.name,
              codes,
              codesCount: codes.length,
            },
          },
        }), () => this.syncPendingFilesToForm(this.state.pendingFiles));
      } catch (error) {
        console.error('Erro ao processar o arquivo:', error);
        alert('Ocorreu um erro ao ler o arquivo. Verifique o formato.');
      }
    };
    reader.readAsBinaryString(file);
  };

  // Remove o arquivo pendente de um produto
  handleRemoveFile = (index) => {
    this.setState((prevState) => {
      const newFiles = { ...prevState.pendingFiles };
      delete newFiles[index];
      return { pendingFiles: newFiles };
    }, () => this.syncPendingFilesToForm(this.state.pendingFiles));
  };

  // Envia os códigos de voucher pendentes de um produto
  handleUploadCodes = async (index, productId) => {
    const actionId = this.props.formValues?.id;
    const fileData = this.state.pendingFiles[index];

    if (!actionId || !productId || !fileData?.codes?.length) {
      alert('Erro: Produto deve ser salvo antes de enviar os códigos.');
      return;
    }

    // Valida novamente que a quantidade de códigos é igual ao estoque
    const stock = parseInt(this.state.products[index]?.stock, 10);
    if (isNaN(stock) || fileData.codes.length !== stock) {
      alert(
        `A quantidade de códigos (${fileData.codes.length}) deve ser igual ao estoque do produto (${
          isNaN(stock) ? 'não definido' : stock
        }).`
      );
      return;
    }

    this.setState({ uploadingIndex: index });

    const voucherData = {
      action_id: actionId,
      product_id: productId,
      codes: fileData.codes,
    };

    try {
      await this.props.uploadVoucherCodes(voucherData);

      // Remove o arquivo pendente após envio com sucesso
      this.setState((prevState) => {
        const newFiles = { ...prevState.pendingFiles };
        delete newFiles[index];
        return { pendingFiles: newFiles };
      }, () => this.syncPendingFilesToForm(this.state.pendingFiles));

      // Atualiza a contagem de vouchers para este produto
      try {
        const count = await this.props.getVoucherCodesCount(productId);
        this.setState((prevState) => ({
          voucherCounts: { ...prevState.voucherCounts, [productId]: count },
        }));
      } catch (err) {
        console.error('Erro ao buscar contagem:', err);
      }
    } catch (err) {
      console.error('Erro ao enviar vouchers:', err);
    } finally {
      this.setState({ uploadingIndex: null });
    }
  };

  // Deleta os códigos de voucher não usados de um produto
  handleDeleteUnusedCodes = async (index, productId) => {
    if (!productId) {
      alert('Erro: Produto deve ser salvo antes de deletar os códigos.');
      return;
    }

    this.setState({ deletingIndex: index });

    try {
      await this.props.deleteUnusedVoucherCodes(productId);

      // Atualiza a contagem de vouchers para este produto
      try {
        const count = await this.props.getVoucherCodesCount(productId);
        this.setState((prevState) => ({
          voucherCounts: { ...prevState.voucherCounts, [productId]: count },
        }));
      } catch (err) {
        console.error('Erro ao buscar contagem:', err);
      }
    } catch (err) {
      console.error('Erro ao deletar vouchers:', err);
    } finally {
      this.setState({ deletingIndex: null });
    }
  };

  handleAddProduct = () => {
    const newProduct = {
      name: '',
      description: '',
      price: 0,
      discount: 0,
      stock: null,
      limit_per_user: null,
      image: null,
    };
    
    const updatedProducts = [...this.state.products, newProduct];
    this.setState({ 
      products: updatedProducts,
      expandedProduct: updatedProducts.length - 1,
    });
    this.props.change('products', updatedProducts);
  };

  handleRemoveProduct = (index) => {
    const updatedProducts = this.state.products.filter((_, i) => i !== index);
    this.setState({ products: updatedProducts });
    this.props.change('products', updatedProducts);
  };

  handleProductChange = (index, field, value) => {
    const updatedProducts = [...this.state.products];
    updatedProducts[index] = {
      ...updatedProducts[index],
      [field]: value,
    };
    this.setState({ products: updatedProducts });
    this.props.change('products', updatedProducts);
  };

  handleProductImageUpload = async (index, event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    try {
      this.setState({ uploadingImage: index });
      
      // Converter arquivo para base64
      const reader = new FileReader();
      reader.onload = async (e) => {
        const base64 = e.target.result;
        
        try {
          // Upload para S3 usando a mesma função do ImageCropModal
          const imagePath = await uploadImageToS3(base64);
          
          this.handleProductChange(index, 'image', imagePath);
        } catch (uploadError) {
          console.error('Erro ao fazer upload da imagem:', uploadError);
        } finally {
          this.setState({ uploadingImage: null });
        }
      };
      reader.readAsDataURL(file);
    } catch (error) {
      console.error('Erro ao processar imagem:', error);
      this.setState({ uploadingImage: null });
    }
  };

  handleTogglePaymentMethod = (method) => {
    const { paymentMethods } = this.state;
    let newMethods;
    
    if (paymentMethods.includes(method)) {
      newMethods = paymentMethods.filter(m => m !== method);
    } else {
      newMethods = [...paymentMethods, method];
    }
    
    this.setState({ paymentMethods: newMethods });
    this.props.change('payment_methods', newMethods);
  };

  onSubmit = (values) => {
    // Salvar no Redux Form
    this.props.change('payment_option', this.state.paymentOption);
    this.props.change('payment_methods', this.state.paymentMethods);
    this.props.change('allow_installments', this.state.allowInstallments);
    this.props.change('installments_count', this.state.installmentsCount);
    this.props.change('installments_free', this.state.installmentsFree);
    this.props.change('use_vouchers', this.state.useVouchers);
    this.props.change('use_own_codes', this.state.useOwnCodes);
    this.props.change('single_product', this.state.singleProduct);
    this.props.change('recurrence_type', this.state.recurrenceType);
    this.props.change('products', this.state.products);
    this.props.change('date_validity_voucher', this.state.dateValidityVoucher);
    
    // Avançar para próxima aba
    this.props.onClickProgress();
  };

  render() {
    const { handleSubmit } = this.props;
    const {
      paymentOption,
      paymentMethods,
      allowInstallments,
      installmentsCount,
      installmentsFree,
      useVouchers,
      useOwnCodes,
      singleProduct,
      recurrenceType,
      products,
      expandedProduct,
      uploadingImage,
      dateValidityVoucher,
      voucherCounts,
      pendingFiles,
      uploadingIndex,
      deletingIndex,
    } = this.state;

    return (
      <form onSubmit={handleSubmit(this.onSubmit)}>
        <div style={{ overflowY: 'scroll', height: 'calc(100vh - 355px)', padding: '0 10px' }}>
          {/* Opções de Resgate */}
          <FormControl fullWidth style={{ marginBottom: 24 }}>
            <InputLabel>Opções de resgate</InputLabel>
            <Select
              value={paymentOption}
              label="Opções de resgate"
              onChange={(e) => {
                this.setState({ paymentOption: e.target.value });
                this.props.change('payment_option', e.target.value);
              }}
            >
              {PAYMENT_OPTIONS.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Tipo de Recorrência */}
          <FormControl fullWidth style={{ marginBottom: 24 }}>
            <InputLabel>Tipo de Venda</InputLabel>
            <Select
              value={recurrenceType}
              label="Tipo de Venda"
              onChange={(e) => {
                const newRecurrenceType = e.target.value;
                const isRecurrent = newRecurrenceType !== 'single';
                const updates = { recurrenceType: newRecurrenceType };
                this.props.change('recurrence_type', newRecurrenceType);

                if (isRecurrent) {
                  updates.paymentMethods = ['credit_card'];
                  updates.allowInstallments = false;
                  this.props.change('payment_methods', ['credit_card']);
                  this.props.change('allow_installments', false);
                }

                this.setState(updates);
              }}
            >
              {RECURRENCE_OPTIONS.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Métodos de Pagamento */}
          {paymentOption !== 'credit_only' && (
            <Box style={{ marginBottom: 24 }}>
              <Typography variant="subtitle2" style={{ marginBottom: 8 }}>
                Métodos de pagamento aceitos:
              </Typography>
              <FormGroup row>
                {PAYMENT_METHODS.map((method) => {
                  const isRecurrent = recurrenceType !== 'single';
                  const isDisabled = isRecurrent && method.value !== 'credit_card';
                  return (
                    <FormControlLabel
                      key={method.value}
                      control={
                        <Checkbox
                          checked={paymentMethods.includes(method.value)}
                          onChange={() => this.handleTogglePaymentMethod(method.value)}
                          color="primary"
                          disabled={isDisabled}
                        />
                      }
                      label={method.label}
                    />
                  );
                })}
              </FormGroup>
              {recurrenceType !== 'single' && (
                <Typography variant="caption" color="textSecondary" style={{ marginTop: 4 }}>
                  Vendas recorrentes aceitam apenas Cartão de Crédito.
                </Typography>
              )}
            </Box>
          )}

          {/* Parcelamento */}
          {paymentOption !== 'credit_only' && recurrenceType === 'single' && (
            <Box style={{ marginBottom: 24 }}>
              <FormControlLabel
                control={
                  <Switch
                    checked={allowInstallments}
                    onChange={(e) => {
                      this.setState({ allowInstallments: e.target.checked });
                      this.props.change('allow_installments', e.target.checked);
                    }}
                    color="primary"
                  />
                }
                label="Permite parcelamento?"
              />

              {allowInstallments && (
                <MaterialGrid container spacing={2} style={{ marginTop: 8 }}>
                  <MaterialGrid item xs={6}>
                    <TextField
                      label="Quantidade de parcelas"
                      type="number"
                      value={installmentsCount}
                      onChange={(e) => {
                        this.setState({ installmentsCount: parseInt(e.target.value) || 1 });
                        this.props.change('installments_count', parseInt(e.target.value) || 1);
                      }}
                      inputProps={{ min: 1, max: 24 }}
                      fullWidth
                      size="small"
                    />
                  </MaterialGrid>
                  <MaterialGrid item xs={6}>
                    <TextField
                      label="Número de parcelas isentas de juros"
                      type="number"
                      value={installmentsFree}
                      onChange={(e) => {
                        this.setState({ installmentsFree: parseInt(e.target.value) || 0 });
                        this.props.change('installments_free', parseInt(e.target.value) || 0);
                      }}
                      inputProps={{ min: 0, max: installmentsCount }}
                      fullWidth
                      size="small"
                    />
                  </MaterialGrid>
                </MaterialGrid>
              )}
            </Box>
          )}

          {/* Opções de Voucher */}
          <Box style={{ marginBottom: 24 }}>
            <FormControlLabel
              control={
                <Switch
                  checked={useVouchers}
                  onChange={(e) => {
                    this.setState({ useVouchers: e.target.checked });
                    this.props.change('use_vouchers', e.target.checked);
                  }}
                  color="primary"
                />
              }
              label="Venda com vouchers"
            />
          </Box>

          <Box style={{ marginBottom: 24 }}>
            <FormControlLabel
              control={
                <Switch
                  checked={useOwnCodes}
                  onChange={(e) => {
                    this.setState({ useOwnCodes: e.target.checked });
                    this.props.change('use_own_codes', e.target.checked);
                  }}
                  color="primary"
                />
              }
              label="Venda com vouchers e códigos próprio"
            />
          </Box>

          {(useVouchers || useOwnCodes) && (
            <Box style={{ marginBottom: 24 }}>
              <TextField
                label="Data de validade do voucher"
                type="datetime-local"
                value={dateValidityVoucher}
                onChange={(e) => {
                  this.setState({ dateValidityVoucher: e.target.value });
                  this.props.change('date_validity_voucher', e.target.value);
                }}
                fullWidth
                size="small"
                InputLabelProps={{ shrink: true }}
                helperText="Exibida no voucher do comprador como prazo de utilização"
              />
            </Box>
          )}

          <Box style={{ marginBottom: 24 }}>
            <FormControlLabel
              control={
                <Switch
                  checked={singleProduct}
                  onChange={(e) => {
                    this.setState({ singleProduct: e.target.checked });
                    this.props.change('single_product', e.target.checked);
                  }}
                  color="primary"
                />
              }
              label="Nessa atividade, o participante poderá comprar apenas um produto"
            />
          </Box>

          {/* Lista de Produtos */}
          <Typography variant="subtitle2" color="primary" style={{ marginBottom: 16 }}>
            {products.length === 0
              ? 'Ainda não há produtos. Adicione alguns!'
              : `${products.length} produto(s) cadastrado(s)`}
          </Typography>

          {products.map((product, index) => (
            <Accordion
              key={index}
              expanded={expandedProduct === index}
              onChange={() => this.setState({ expandedProduct: expandedProduct === index ? -1 : index })}
              style={{ marginBottom: 8 }}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Box style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
                  <Typography>
                    {product.name || `Produto ${index + 1}`}
                  </Typography>
                  <Button
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      this.handleRemoveProduct(index);
                    }}
                    style={{ color: '#f44336' }}
                  >
                    Excluir Produto
                  </Button>
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <MaterialGrid container spacing={2}>
                  <MaterialGrid item xs={12}>
                    <TextField
                      label="Nome do produto"
                      value={product.name}
                      onChange={(e) => this.handleProductChange(index, 'name', e.target.value)}
                      fullWidth
                      size="small"
                      helperText="Indique o seu produto, marca e modelo. Evite usar condições de vendas."
                    />
                  </MaterialGrid>

                  <MaterialGrid item xs={12}>
                    <Typography variant="caption" display="block" gutterBottom>
                      Imagem do Produto
                    </Typography>
                    <input
                      type="file"
                      accept="image/png,image/jpeg,image/jpg"
                      id={`product-image-${index}`}
                      style={{ display: 'none' }}
                      onChange={(e) => this.handleProductImageUpload(index, e)}
                    />
                    <label htmlFor={`product-image-${index}`}>
                      <Box
                        style={{
                          border: '1px dashed #ccc',
                          borderRadius: 8,
                          padding: 24,
                          textAlign: 'center',
                          cursor: uploadingImage === index ? 'wait' : 'pointer',
                          backgroundColor: '#f9f9f9',
                          minHeight: 200,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          overflow: 'hidden',
                        }}
                      >
                        {uploadingImage === index ? (
                          <Box>
                            <Typography variant="body2" color="primary">
                              Enviando imagem...
                            </Typography>
                          </Box>
                        ) : product.image ? (
                          <img 
                            src={product.image.startsWith('http') ? product.image : `${BASE_S3}/${product.image}`}
                            alt="Imagem do produto"
                            style={{
                              maxWidth: '100%',
                              maxHeight: 180,
                              objectFit: 'contain',
                            }}
                          />
                        ) : (
                          <Box>
                            <Typography variant="body2" color="textSecondary">
                              Clique para selecionar imagem
                            </Typography>
                            <Typography variant="caption" display="block" color="textSecondary" style={{ marginTop: 4 }}>
                              Formatos: .png ou .jpg
                            </Typography>
                            <Typography variant="caption" display="block" color="textSecondary">
                              Tamanho recomendado: 800x600px
                            </Typography>
                          </Box>
                        )}
                      </Box>
                    </label>
                    {product.image && (
                      <Button
                        size="small"
                        color="secondary"
                        onClick={() => this.handleProductChange(index, 'image', null)}
                        style={{ marginTop: 4 }}
                      >
                        Remover imagem
                      </Button>
                    )}
                  </MaterialGrid>

                  <MaterialGrid item xs={12}>
                    <TextField
                      label="Descrição do produto"
                      value={product.description}
                      onChange={(e) => this.handleProductChange(index, 'description', e.target.value)}
                      fullWidth
                      multiline
                      rows={3}
                      size="small"
                    />
                  </MaterialGrid>

                  <MaterialGrid item xs={6} sm={3}>
                    <TextField
                      label="Preço (R$)"
                      type="number"
                      value={product.price}
                      onChange={(e) => this.handleProductChange(index, 'price', parseFloat(e.target.value) || 0)}
                      inputProps={{ min: 0, step: 0.01 }}
                      fullWidth
                      size="small"
                    />
                  </MaterialGrid>

                  <MaterialGrid item xs={6} sm={3}>
                    <TextField
                      label="Desconto (R$)"
                      type="number"
                      value={product.discount || ''}
                      onChange={(e) => this.handleProductChange(index, 'discount', parseFloat(e.target.value) || 0)}
                      inputProps={{ min: 0, step: 0.01 }}
                      fullWidth
                      size="small"
                      helperText={product.discount > 0 ? `Final: R$ ${((product.price || 0) - (product.discount || 0)).toFixed(2)}` : ''}
                    />
                  </MaterialGrid>

                  <MaterialGrid item xs={6} sm={2}>
                    <TextField
                      label="Estoque"
                      type="number"
                      value={product.stock || ''}
                      onChange={(e) => this.handleProductChange(index, 'stock', parseInt(e.target.value) || null)}
                      inputProps={{ min: 0 }}
                      fullWidth
                      size="small"
                      helperText="Ilimitado"
                    />
                  </MaterialGrid>

                  <MaterialGrid item xs={6} sm={4}>
                    <TextField
                      label="Limite por usuário"
                      type="number"
                      value={product.limit_per_user || ''}
                      onChange={(e) => this.handleProductChange(index, 'limit_per_user', parseInt(e.target.value) || null)}
                      inputProps={{ min: 0 }}
                      fullWidth
                      size="small"
                      helperText="Deixe vazio para ilimitado"
                    />
                  </MaterialGrid>

                  {/* Importação de códigos de vouchers próprios */}
                  {useOwnCodes && (
                    <MaterialGrid item xs={12}>
                      <Divider style={{ margin: '16px 0' }} />
                      <FormControlLabel
                        control={
                          <Switch
                            checked={Boolean(product.has_voucher_import)}
                            onChange={(e) => this.handleProductChange(index, 'has_voucher_import', e.target.checked)}
                            color="primary"
                          />
                        }
                        label="Importar códigos de vouchers para este produto?"
                      />

                    {product.has_voucher_import && (
                      <Box
                        style={{
                          width: '100%',
                          border: '1px solid #E5E5E5',
                          borderRadius: 8,
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'center',
                          alignItems: 'center',
                          padding: 20,
                          marginTop: 12,
                        }}
                      >
                        <Typography variant="subtitle2" style={{ fontWeight: 'bold', marginBottom: 8 }}>
                          Importar Códigos de Vouchers
                        </Typography>

                        {/* Contagem de vouchers já importados */}
                        {voucherCounts && voucherCounts[product.id] && (
                          <Box
                            style={{
                              backgroundColor: '#e8f5e9',
                              borderRadius: 8,
                              padding: '12px 20px',
                              marginBottom: 16,
                              textAlign: 'center',
                              width: '100%',
                            }}
                          >
                            <Typography style={{ fontWeight: 'bold', fontSize: 14, color: '#2e7d32', marginBottom: 4 }}>
                              Vouchers já importados
                            </Typography>
                            <Typography style={{ fontSize: 13, color: '#1b5e20' }}>
                              Total: {voucherCounts[product.id]?.total || 0} | Disponíveis:{' '}
                              {voucherCounts[product.id]?.available || 0} | Usados:{' '}
                              {voucherCounts[product.id]?.used || 0}
                            </Typography>
                            {(voucherCounts[product.id]?.available || 0) > 0 && (
                              <Button
                                size="small"
                                disabled={deletingIndex === index}
                                onClick={() => {
                                  if (
                                    window.confirm(
                                      'Tem certeza que deseja deletar todos os códigos não usados deste produto?'
                                    )
                                  ) {
                                    this.handleDeleteUnusedCodes(index, product.id);
                                  }
                                }}
                                style={{
                                  marginTop: 8,
                                  backgroundColor: deletingIndex === index ? '#ccc' : '#f44336',
                                  color: '#fff',
                                }}
                              >
                                {deletingIndex === index ? 'Deletando...' : 'Deletar códigos não usados'}
                              </Button>
                            )}
                          </Box>
                        )}

                        {/* Arquivo selecionado ou área de drop */}
                        {pendingFiles && pendingFiles[index] ? (
                          <Box
                            style={{
                              width: '100%',
                              border: '2px solid #4caf50',
                              borderRadius: 8,
                              padding: 20,
                              textAlign: 'center',
                              backgroundColor: '#e8f5e9',
                            }}
                          >
                            <Typography style={{ fontWeight: 'bold', fontSize: 14, color: '#2e7d32', marginBottom: 4 }}>
                              Arquivo selecionado: {pendingFiles[index].fileName}
                            </Typography>
                            <Typography style={{ fontSize: 13, color: '#388e3c', marginBottom: 12 }}>
                              {pendingFiles[index].codesCount} códigos encontrados
                            </Typography>
                            <Box style={{ display: 'flex', gap: 10, justifyContent: 'center' }}>
                              <Button
                                size="small"
                                onClick={() => this.handleRemoveFile(index)}
                                style={{ backgroundColor: '#f44336', color: '#fff' }}
                              >
                                Remover arquivo
                              </Button>
                              <Button
                                size="small"
                                disabled={uploadingIndex === index}
                                onClick={() => {
                                  if (!product.id) {
                                    alert('Salve a atividade primeiro para obter o ID do produto.');
                                    return;
                                  }
                                  this.handleUploadCodes(index, product.id);
                                }}
                                style={{
                                  backgroundColor: uploadingIndex === index ? '#ccc' : '#4caf50',
                                  color: '#fff',
                                }}
                              >
                                {uploadingIndex === index ? 'Enviando...' : 'Enviar códigos'}
                              </Button>
                            </Box>
                          </Box>
                        ) : (
                          <Box
                            style={{
                              width: '100%',
                              border: '2px dashed #ccc',
                              borderRadius: 8,
                              padding: 30,
                              textAlign: 'center',
                              backgroundColor: '#fafafa',
                              cursor: 'pointer',
                            }}
                            onDragOver={(e) => e.preventDefault()}
                            onDrop={(e) => {
                              e.preventDefault();
                              this.handleFileSelect(index, e);
                            }}
                            onClick={() => document.getElementById(`voucher-file-upload-${index}`).click()}
                          >
                            <Typography style={{ fontWeight: 'bold', fontSize: 14, marginBottom: 4 }}>
                              Arraste o arquivo aqui
                            </Typography>
                            <Typography variant="caption" color="textSecondary" display="block">
                              ou clique para selecionar
                            </Typography>
                            <Typography variant="caption" color="textSecondary">
                              Formatos aceitos: .csv, .xlsx, .xls
                            </Typography>
                          </Box>
                        )}
                        <input
                          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                          style={{ display: 'none' }}
                          id={`voucher-file-upload-${index}`}
                          type="file"
                          onChange={(e) => this.handleFileSelect(index, e)}
                        />
                      </Box>
                    )}
                    </MaterialGrid>
                  )}
                </MaterialGrid>
              </AccordionDetails>
            </Accordion>
          ))}

          {/* Botão Adicionar Produto */}
          <Button
            variant="text"
            color="primary"
            startIcon={<AddIcon />}
            onClick={this.handleAddProduct}
            fullWidth
            style={{ marginBottom: 16 }}
          >
            + Adicionar Produto
          </Button>
        </div>

        {/* Botões */}
        <MaterialGrid
          container
          display="flex"
          justifyContent="space-around"
          alignItems="center"
          style={{ margin: '25px 0px', overflowX: 'hidden' }}>
          <SecondaryButton
            type="button"
            color="secondary"
            onClick={this.props.goBack}
            style={{ margin: 0, width: '48%', padding: '10px 20px', textTransform: 'none' }}>
            Voltar
          </SecondaryButton>
          <PrimaryButton
            type="submit"
            color="primary"
            style={{ margin: 0, width: '48%', padding: '10px 20px', textTransform: 'none' }}>
            Salvar e continuar
          </PrimaryButton>
        </MaterialGrid>

      </form>
    );
  }
}

Produto.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  formValues: PropTypes.object,
  onClickProgress: PropTypes.func.isRequired,
  goBack: PropTypes.func.isRequired,
  handleCancelClose: PropTypes.func.isRequired,
  openConfirmation: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  confirmationTitle: PropTypes.string,
  confirmationSubtitle: PropTypes.string,
  buttonConfirmationLabel: PropTypes.string,
  change: PropTypes.func.isRequired,
  uploadVoucherCodes: PropTypes.func.isRequired,
  getVoucherCodesCount: PropTypes.func.isRequired,
  deleteUnusedVoucherCodes: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  formValues: getFormValues('vendasOnlineParceiroForm')(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      change: (field, value) => change('vendasOnlineParceiroForm', field, value),
      uploadVoucherCodes,
      getVoucherCodesCount,
      deleteUnusedVoucherCodes,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: 'vendasOnlineParceiroForm',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  })(Produto)
);
